export enum RecurringChangeTypeEnum {
    ChangePattern = 0,
    NormalToRecurring = 1,
    RecurringToNormal = 2
}